import { SpaceAccessLevel } from "types/generated";

export const hasSpaceManageAccess = (accessLevel: SpaceAccessLevel) =>
  accessLevel === SpaceAccessLevel.Admin;
